(function(){
  function initFilter(root){
    if(root._jmc)return;root._jmc=1;
    var chips=root.querySelectorAll('.jmc-chip');if(!chips.length)return;
    var cards=root.querySelectorAll('.jmc-grid__list .jmh-card');
    chips.forEach(function(c){c.addEventListener('click',function(){
      var cat=c.getAttribute('data-cat');
      chips.forEach(function(x){x.setAttribute('aria-pressed',x===c?'true':'false')});
      cards.forEach(function(k){var t=(k.getAttribute('data-jmh-tabs')||'').trim();k.hidden=!(cat==='all'||t===cat)});
    })});
  }
  function initProgress(root){
    if(root._jmcp)return;root._jmcp=1;
    var row=root.querySelector('.jmh-row'),bar=root.querySelector('.jmc-progress__bar'),track=root.querySelector('.jmc-progress');
    if(!row||!bar||!track)return;
    function upd(){var sw=row.scrollWidth,cw=row.clientWidth;var f=sw>0?Math.min(1,cw/sw):1;var tw=track.clientWidth;var w=Math.max(24,tw*f);
      bar.style.width=w+'px';var max=sw-cw;var p=max>0?row.scrollLeft/max:0;bar.style.transform='translateX('+((tw-w)*p)+'px)';
      track.style.visibility=f>=0.999?'hidden':'visible';}
    row.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);
    root.querySelectorAll('.jmh-tab').forEach(function(t){t.addEventListener('click',function(){setTimeout(upd,30)})});
    upd();setTimeout(upd,400);
  }
  function init(scope){
    (scope||document).querySelectorAll('[data-jmc-filter]').forEach(initFilter);
    (scope||document).querySelectorAll('[data-jmc-progress]').forEach(initProgress);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init()});else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
